import { SetShowEndScreen } from "../components/end";

export function toggleEndScreen(
  setShowEndScreen: SetShowEndScreen,
  showEndScreen: boolean
) {
  console.log("hii", !showEndScreen);
  setShowEndScreen(!showEndScreen);
}
